(function () {
  'use strict';
 
  var dataEl = document.getElementById('gobi-stock-data');
  if (!dataEl) return;
 
  var datos;
  try {
    datos = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.warn('[gobi-stock] No se ha podido leer el JSON de datos', e);
    return;
  }
 
  var stock = datos.stock || {};
  var mensajes = datos.mensajes || {};
 
  // Busca la variante seleccionada entre todos los formularios de compra,
  // quedándose con el primero cuyo valor pertenezca a este producto.
  function varianteActual() {
    var campos = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    for (var i = 0; i < campos.length; i++) {
      var valor = String(campos[i].value);
      if (Object.prototype.hasOwnProperty.call(stock, valor)) return valor;
    }
 
    var param = new URLSearchParams(window.location.search).get('variant');
    if (param && Object.prototype.hasOwnProperty.call(stock, param)) return param;
 
    return datos.inicial ? String(datos.inicial) : null;
  }
 
  // Aplica el estado a todos los mensajes. Solo toca el DOM si algo cambia,
  // así que es seguro llamarla muchas veces.
  function aplicar() {
    var id = varianteActual();
    if (!id) return;
 
    var hayStock = stock[id] === true;
    var textoEnvio = hayStock ? mensajes.envio : mensajes.envioSinStock;
    var displayReposicion = hayStock ? 'none' : '';
 
    document.querySelectorAll('.js-msg-envio').forEach(function (el) {
      if (textoEnvio && el.textContent.trim() !== textoEnvio) {
        el.textContent = textoEnvio;
      }
      el.classList.toggle('is-sin-stock', !hayStock);
    });
 
    document.querySelectorAll('.js-msg-reposicion').forEach(function (el) {
      if (el.style.display !== displayReposicion) {
        el.style.display = displayReposicion;
      }
    });
  }
 
  // Los temas actualizan la variante con cierto retraso, por eso se
  // comprueba justo después y un poco más tarde.
  function aplicarPronto() {
    setTimeout(aplicar, 50);
    setTimeout(aplicar, 300);
  }
 
  // Eventos de interacción y eventos propios de distintos temas
  ['change', 'click', 'variant:change', 'variant:update'].forEach(function (evento) {
    document.addEventListener(evento, aplicarPronto);
  });
  window.addEventListener('popstate', aplicarPronto);
 
  // Muchos temas cambian ?variant= en la URL al seleccionar talla
  ['pushState', 'replaceState'].forEach(function (metodo) {
    var original = history[metodo];
    history[metodo] = function () {
      var resultado = original.apply(this, arguments);
      aplicarPronto();
      return resultado;
    };
  });
 
  // Red de seguridad: cubre temas que regeneran el HTML de la ficha
  // o que cambian la variante sin lanzar ningún evento.
  setInterval(aplicar, 500);
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aplicar);
  } else {
    aplicar();
  }
})();